import messages from './tag-messages.js';
export default [
    {tag: 'edu', intlLabel: messages.edu},
    {tag: 'entry', intlLabel: messages.entry},
    {tag: 'edu_and_entry', intlLabel: messages.allmonitor}
];
